<template>
    <div class="main-container">
        <div ref="storyOwner"
             class="story-owner"
             v-line-clamp="titleLines">
            {{ formatOwners(members) }}
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import breakpoints from '@/libs/breakpoints'
import lineClamp from 'vue-line-clamp'
Vue.use(lineClamp, {
  textOverflow: 'ellipsis'
})

export default {
  props: ['members', 'customLineClamp'],
  computed: {
    isMobile: function () {
      return breakpoints.isMobile()
    },
    titleLines: function () {
      return this.customLineClamp ? this.customLineClamp : 2
    }
  },
  methods: {
    formatOwners: function (owners) {
      if (typeof owners === 'string') return owners

      return owners.map(owner => {
        const fullName = `${owner.user.firstName ?? ''} ${owner.user.lastName ?? ''}`
        return fullName.trim() || owner.user.fullName || owner.user.userName
      }).join(', ')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';
.story-owner {
  overflow: visible;
  word-break: break-word;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  font-family: 'Helvetica Neue';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #848589;
  margin: 0.4rem 1rem;
  max-height: 33px;
}

.main-container {
  height: auto;
}
</style>
